/* istanbul ignore file*/
import {
    OVERLAY_ANIMATION_SLIDE,
    IOverlayBusinessLogic,
    Overlay,
    createOverlay,
} from '@vfde-brix/ws10/overlay';
import { NAME_OVERLAY } from '../constants';
import { getFiberObject, setFiberProperty } from '../util/cms';
import { getQueryParam } from '@vfde-sails/utils';
import { QueryNames } from '../enums/network';
import { OverlayContent } from '../enums/elementId';
import { Actions } from 'Container/PriceSection';
import { blurAll } from '../util/visibility';

/**
 * Mount overlay component
 */
export const mountOverlayComponent = (onCloseHandler: Function) => {
    const overlayWrapper = document.createElement('div');
    const business: IOverlayBusinessLogic = {
        onOpen: () => {},
        onClose: () => {
            blurAll();
            onCloseHandler();
        },
    };

    document.body.appendChild(overlayWrapper);

    const overlay = createOverlay(overlayWrapper, {
        optPaddingLayout: true,
        optAnimation: OVERLAY_ANIMATION_SLIDE,
        business,
    });

    setFiberProperty(NAME_OVERLAY, overlay);

    return overlay;
};

/**
 * Opens or closes the overlay, by default opens it
 *  @param isOpen true: opens the ovelay , false: closes it.
 */
export const setOverlayVisiblity = (isOpen: boolean = true) => {
    const overlay: Overlay | undefined = getFiberObject()?.overlay;

    isOpen ? overlay?.open() : overlay?.close();
};

/**
 * Opens the overlay if overlay param = true
 *  @param isAutoOverlayOpened true: opens the ovelay.
 */
export const setAutoOverlayOpen = (actions:Actions, isAutoOverlayOpened: boolean = true) => {
    const overlayParam = getQueryParam(QueryNames.OVERLAY);

    if (overlayParam && 'true' === overlayParam && !isAutoOverlayOpened){
        actions.openOverlay(OverlayContent.FORM, true);
        actions.resetForm();
    }
};
